import React, { memo } from 'react';

import { log } from '../../services/utils';

import { useAuthState } from '../../contexts/AuthContext';

import NavItem from '../Shared/NavItem';
import PermissionsWrapper from '../PermissionsWrapper';

import styles from './sidebar.module.css';

const AgenciesSidebar = () => {
	const { user: { permissions } } = useAuthState();

	return (
		<div className={ styles.sidebarMenuContainer }>
			{ log( 'agenciesSidebar' ) }
			<PermissionsWrapper permission={ permissions.listAgencies.isAvailable }>
				<NavItem
					className={ styles.sidebarLink }
					icon="address book"
					title="Directory"
					to="/agencies/directory"
				/>
			</PermissionsWrapper>
			<PermissionsWrapper permission={ permissions.listAgencies.isAvailable }>
				<NavItem
					className={ styles.sidebarLink }
					icon="tasks"
					title="Onboarding"
					to="/agencies/onboarding"
				/>
			</PermissionsWrapper>
		</div>
	);
};

export default memo( AgenciesSidebar );
